import OMWarningModal from './o-m-warning-modal.vue';

export default OMWarningModal;